import type { RouteRecordRaw } from 'vue-router';
import { useBrandComponent } from '@/composables/useBrandComponent';
import { CLIENTS_ROUTE_PATH } from '../config/clients';

const clientsComponent = useBrandComponent('modules/clients-v2/views/ClientsView.vue');
const clientsMeta = {
    requiresAuth: true,
    // Nombre corto, igual al ítem del menú v2 ('Clientes', decisión N-1
    // 2-sep-2026, menuV2.ts). Mismo criterio aplicado a Folios y Pólizas
    // (triage 2026-09-24): la pestaña del navegador usa el nombre corto del
    // menú v2, no el largo heredado del menú v1 (sidebarItem.ts).
    title: 'Clientes',
    requiresPermission: 'brokerin',
    minLevel: 20,
    requiresSystemPermission: 'my_clients',
    // `FullLayout.vue` usa `route.meta?.keyGroup ?? route.name` como `:key`
    // del `<RouterView>` para forzar remount al cambiar de página. Listado,
    // detalle y alta de Clientes v2 son la MISMA instancia de componente
    // (`ClientsView.vue` cambia de modo leyendo `route.params.hash` / el
    // nombre de ruta, ver comentario de `clientsRoutes` abajo) a propósito,
    // para no perder el estado del listado (búsqueda, filtros, vista activa)
    // al entrar al detalle de un cliente y volver. Con el `:key` por
    // `route.name` por defecto, cada ida y vuelta detalle↔listado remonta
    // `ClientsView.vue` desde cero y pierde ese estado (bug reportado en QA:
    // "hago un filtro, entro al detalle y regreso, ya no está el filtro").
    // Un `keyGroup` compartido entre las 6 rutas de este módulo mantiene la
    // instancia viva; el resto de la app conserva el remount por nombre.
    keyGroup: 'clients-v2'
};

/**
 * Rutas de Mis Clientes.
 *
 * `/private/clients` es la ruta oficial del listado; `/private/clients/:hash`
 * es el detalle de un cliente, con su hash en la URL para que recargar (F5)
 * mantenga la ficha abierta en vez de volver al listado. `/private/clients/new`
 * es el mismo patrón para el alta: mantiene el formulario de creación abierto
 * al recargar en vez de perderlo (antes compartía URL con el listado). El
 * mismo componente `ClientsView.vue` maneja los tres modos leyendo
 * `route.params.hash` / el nombre de la ruta actual.
 *
 * `/clientes` (y sus `/clientes/:hash`, `/clientes/new`) es un alias local
 * para validar el módulo real con la URL usada en el diseño, sin apuntar al
 * catálogo dummy de `vue-html-final`.
 *
 * v2 queda fija (cierre de rediseño): VITE_DISABLE_MY_CLIENTS se elimina, ya
 * no hay forma de apagar el módulo por variable de entorno.
 */
export const clientsRoutes: RouteRecordRaw[] = [
    {
        path: CLIENTS_ROUTE_PATH,
        name: 'Mis Clientes v2',
        component: clientsComponent,
        meta: clientsMeta
    },
    {
        path: `${CLIENTS_ROUTE_PATH}/new`,
        name: 'Mis Clientes v2 Crear',
        component: clientsComponent,
        meta: clientsMeta
    },
    {
        path: `${CLIENTS_ROUTE_PATH}/:hash`,
        name: 'Mis Clientes v2 Detalle',
        component: clientsComponent,
        meta: clientsMeta
    },
    {
        path: '/clientes',
        name: 'Clients Local',
        component: clientsComponent,
        meta: clientsMeta
    },
    {
        path: '/clientes/new',
        name: 'Clients Local Crear',
        component: clientsComponent,
        meta: clientsMeta
    },
    {
        path: '/clientes/:hash',
        name: 'Clients Local Detalle',
        component: clientsComponent,
        meta: clientsMeta
    }
];
